import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BackButton.css';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide back button on these pages
  const hideOnPages = ['/', '/dashboard', '/login', '/register'];
  const shouldHide = hideOnPages.includes(location.pathname);

  const handleBack = () => {
    navigate(-1); // Go back in browser history
  };

  if (shouldHide) {
    return null;
  }

  return (
    <div className="back-button-container">
      <button className="back-button" onClick={handleBack} aria-label="Go back">
        ← Back
      </button>
    </div>
  );
};

export default BackButton;

